export const phoneMask = '999999999999'
